module.exports = __webpack_public_path__ + "static/media/buy_rating_2.763feb8b.jpg";